import Swal from 'sweetalert2';
const VueToast = (function () {
    function VueToast() {}
    VueToast.install = function (vue, options) {
        let _toast = function () {
            let args = [];
            for (let _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }

            let mixed = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 5000
            });
            return mixed.fire.apply(mixed, args);
        };
        vue['toast'] = _toast;
        if (!vue.prototype.hasOwnProperty('$toast')) {
            vue.prototype.$toast = _toast;
        }
    };
    return VueToast;
}());
export default VueToast;
